import styled, { css } from 'styled-components';
import { setAlpha } from '../../styles';
import { Box } from '../Core';
import { AlertVariants } from './types';

export const AlertWrapper = styled(Box)<{ isBordered: boolean; variant: AlertVariants; flatNegative?: boolean }>`
  ${({ isBordered, theme }) =>
    isBordered &&
    css`
      border-radius: 3px;
      border: solid 1px ${theme.colors.gray['050']};
    `}

  ${({ theme }) => css`
    background: ${setAlpha(0.04, theme.colors.gray['100'])};
    border: solid 1px ${theme.colors.gray['050']};
    color: ${theme.colorTextImportant};
  `}

  ${({ variant, theme }) =>
    variant === AlertVariants.Guide &&
    css`
      background: ${setAlpha(0.16, theme.colors.blue.default)};
      border: solid 1px ${setAlpha(0.04, theme.colors.blue.default)};
    `}

  ${({ variant, flatNegative, theme }) =>
    variant === AlertVariants.Negative &&
    !flatNegative &&
    css`
      background: ${setAlpha(0.4, theme.colors.red.default)};
      border: solid 1px ${setAlpha(0.14, theme.colors.red.default)};
    `}
`;

AlertWrapper.defaultProps = {
  display: 'flex',
  alignItems: 'flex-start',
  justifyContent: 'flex-start',
  flex: 1,
  gap: 'spacing8',
  p: 'spacing8',
  fontSize: 'fontSizeDefault',
};
